<template>
  <div>

    <div v-if="links_loaded == false">
    <center>
      <br>
      <Preloader v-if="error_msg_ll==''" class="preload"></Preloader>
      <br>
      <span  v-if="error_msg_ll==''" class="green-text">Loading Links...</span> 
      <span v-else  class="red-text">{{error_msg_ll}}</span> <br> <br> 
    </center>
  </div>

    <div v-else>
      <div id="divid_search" class="col s12 m12 l12">
        <h5 class="pink-text darken-4">
          <span @click="show_desc_all">
            <i v-if="show_desc_bool" class="material-icons green white-text">add_circle_outline</i>
            <i v-else class="material-icons green white-text">remove_circle_outline</i>
            My Links
          </span>
          |
          <span class="right-align" style="color:gray;font-size:12px;margin-top:0px;">
            <b>{{filteredLinks.length}}</b> Results Found ...
          </span>

          <input
            type="text"
            id="txtid_search_link"
            v-model="search_text"
            autocomplete="off"
            placeholder="Enter Search Text...."
          />
        </h5>
      </div>

      <div id="divid_tblwraper">
        <span v-if="filteredLinks.length == 0">
          <br />
          <br />
          <br />
          <center class="orange-text">No data to show...</center>
        </span>

        <table id="tblid_list" class="bordered stripped collection with-header">
          <!---- collection with-header-->

          <tbody>
            <tr v-for="(link,no) in filteredLinks" :key="no" class="collection-item">
              <td v-on:click="show_desc_curr">
                <span :id="no" :title="no+1" class="list_text">
                  [ +/- ]

                  <span :title="link.link_type" @click="show_msg(link.link_type)">
                    <i v-if="link.link_type == 'Public'" class="fa fa-globe green-text"></i>
                    <i v-if="link.link_type == 'Private'" class="fa fa-lock red-text"></i>
                    <i v-if="link.link_type == 'Friends'" class="fa fa-handshake-o yellow-text"></i>
                    <i v-if="link.link_type == 'Family'" class="fa fa-users orange-text"></i>
                    
                  </span>

                  {{link.link_name}} | {{link.link_category}}
                </span>

                <router-link
                  class="secondary-content"
                  :to="{name:'view-linkinfo',params:{link_id:link.link_id}}"
                >
                  <i class="fa fa-eye"></i>
                </router-link>
                <br />

                <a :href="link.link_url" target="_blank">{{link.link_id}}:{{link.link_url}}</a>
                <br />
                <div :id="`d`+no" class="linkdesc" hidden>
                  <b>Description :</b>
                  <span v-html="link.link_desc.replace(/\n/g, '<br />')"></span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />

      <div class="fixed-action-btn">
        <router-link
          name="addnew-linkinfo"
          to="/new"
          :key="$route.fullPath"
          class="btn-floating btn-large red"
        >
          <i class="fa fa-plus"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
//import db from "./firebaseInit";
import Preloader from "./Preloader";

export default {
  name: "link-showall",

  components: {
    Preloader
  },

  data() {
    return {
      //linko_id: "", //linko id of current user whose profile and data is to be loaded
      //links: this.$store.state.links,

      //profile_data:'',
      search_text: "",
      show_desc_bool: true,
      show_desc_curr_bool: true,
    };
  },

  created() {

  },
  methods: {
    show_desc_curr(event) {
      var id = "#d" + event.target.id; //read and compose id with #
      $(id).toggle();
      this.show_desc_curr_bool = !this.show_desc_curr_bool;
    },
    show_desc_all() {
      $(".linkdesc").toggle();
      this.show_desc_bool = !this.show_desc_bool;
    },
    show_msg(msg){
      alert(msg +"  Link");
    }
  },

  computed: {
/* 
    links_count:function(){
      return this.$store.state.links_count;
    }, 
 */

    //Get all Links accessible to current user.
    links:function() {
      console.log("in LinkShowAll->computed.links()");
      return this.$store.state.links;
    },

    links_loaded:function() {
      return this.$store.state.links_loaded;
    },
    error_msg_ll:function() {
      return this.$store.state.error_msg_ll;      
    },

    // user_name:this.$store.state.links,
    filteredLinks:function() {

/*       if (this.links_count == 0) {
        console.log("Links count : "+this.links_count)
        return; //Do not apply filter function below if list is emply, otherwise it throws error
      }
       */
      return this.links.filter(link => {
        window.scrollTo(0, 240);
        var f1, f2, f3, f4, f5,f6;
        f1 = link.link_url
          .toLowerCase()
          .includes(this.search_text.toLowerCase());
        f2 = link.link_name
          .toLowerCase()
          .includes(this.search_text.toLowerCase());
        f3 = link.link_desc
          .toLowerCase()
          .includes(this.search_text.toLowerCase());
        f4 = link.link_type
          .toLowerCase()
          .includes(this.search_text.toLowerCase());
        f5 = link.link_category
          .toLowerCase()
          .includes(this.search_text.toLowerCase());
        f6 = link.link_id
          .toLowerCase()
          .includes(this.search_text.toLowerCase());
        return f1 || f2 || f3 || f4 || f5 || f6; //returning final boolean value
      });
    }
  },

  mounted: function() {
    /*    
      //delay for few sec to ensure that dom is loaded, else slider doesnt starts
    setTimeout(function() { $('.slider').slider();
      var tbl_width = $("#tblid_list").width();
      $("#txtid_search_link").width(tbl_width-5);
    }, 2000);
  */
    console.log("in LinkShowAll->Mounted");
    this.$store.dispatch("loadLinksInfo"); //It will call the loadLinksInfo method in action of store.js

    window.onscroll = function() {
      var tbl_width = $("#tblid_list").width();

      //console.log(tbl_width,scrollY-300);
      if (scrollY > 320) {
        $("#divid_search").addClass("fix_top");
        $("#divid_search").width(tbl_width + 4);
        $("#txtid_search_link").width(tbl_width - 5);
      } else if (scrollY - 300 < -60) $("#divid_search").removeClass("fix_top");
    };
  }
};
</script>



<style scoped>
#loader {
  height: 600px;
}

.preload {
  margin: 10px;
}
.srno {
  width: 10px;
  background: gray;
  font-size: 18px;
}
.chip {
  width: 35px;
}
.linkdesc {
  color: gray;
  text-align: justify;
}

.list_text {
  font-size: 15px;
}
#txtid_search_link {
  background: #f6f6f8;
  padding-left: 5px;
  margin-left: 2px;
  border-radius: 2px;
}

#divid_tblwraper {
  min-height: 450px;
  border: solid 1px gray;
  border-radius: 5px;
}

td {
  padding: 5px;
}
#divid_search {
  background: black;
}

.fix_top {
  position: fixed;
  top: 50px;

  z-index: 200;
}

/*
.circle {
  width: 125px;
  border: solid 1px white;
}

#id_profile_pic,
#id_activity_pics,
#id_social_links,
#id_user_bio {
  background: #eeeeee;
  border-radius: 5px;
  border: solid 1px #eeeeee;
}

#id_profile_pic {
  height: 200px;
  padding-top: 40px;
  background: black;
}

#id_activity_pics {
  height: 200px;
  background: black;
}

#id_social_links {
  background: #f6f6f8;
  font-size: 14px;
  text-align: justify;
}

#id_user_bio {
  padding-top: 5px;
  margin-top: 5px;
}

.slider,
ul {
  width: 100%;
  height: 100% !important;
}

#pp_sm {
  width: 100px;
  position: relative;
  top: -185px;
  left: 15px;
  z-index: 50;
}
*/

#tblid_list td {
  word-break: break-word;
}
</style>




// WEBPACK FOOTER //
// src/components/LinkShowAll.vue